import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { OrganizationKeyName } from "../model/Organization";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import { EmailTemplatesSuccessResponse } from "../module/email-template/models/EmailTemplatesSuccessResponse";
import { EmailTemplate } from "../module/email-template/models/EmailTemplate";
import { map } from "rxjs/operators";

export class ApiEmailTemplate {
  constructor(private apiEndpoint: string) {}

  listAll(
    token: string,
    organization: OrganizationKeyName
  ): Observable<EmailTemplatesSuccessResponse> {
    return ajax({
      url: `${this.apiEndpoint}/organizations/${organization}/email-templates`,
      method: "GET",
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x) => x.response));
  }

  sendTest(
    token: string,
    organization: OrganizationKeyName,
    data: Partial<EmailTemplate>
  ): Observable<null> {
    return ajax({
      url: `${this.apiEndpoint}/organizations/${organization}/email-templates/send-test`,
      method: "POST",
      body: data,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x) => x.response));
  }
}
